import { BuildingBalanceResponseBody, LandBalanceResponseBody } from "../../api/ReportResponseTypes";
import { FormattedDecimal } from "../../util/conversionUtils";

export enum AssetType {
  HOONE = "HOONE",
  MAA = "MAA",
}

export enum SubmitType {
  SEARCH = "SEARCH",
  EXPORT = "EXPORT",
  CREATE_WORKSPACE = "CREATE_WORKSPACE",
}

export interface LandBalance
  extends Omit<LandBalanceResponseBody, "kogupindalaM2" | "kogupindalaHa" | "soetusmaksumus"> {
  kogupindalM2?: FormattedDecimal;
  kogupindalaHa?: FormattedDecimal;
  soetusmaksumus?: FormattedDecimal;
}
export interface BuildingBalance
  extends Omit<BuildingBalanceResponseBody, "riigivaraPind" | "soetusmaksumus" | "jaakvaartus"> {
  riigivaraPind?: FormattedDecimal;
  soetusmaksumus?: FormattedDecimal;
  jaakvaartus?: FormattedDecimal;
}
